import React, { ReactNode, createContext, useContext, useMemo } from 'react';

type ViewerLayoutMode = 'default' | 'patient-mobile';

type ViewerLayoutContextValue = {
  layoutMode: ViewerLayoutMode;
  isPatientMobile: boolean;
};

const defaultValue: ViewerLayoutContextValue = {
  layoutMode: 'default',
  isPatientMobile: false,
};

const ViewerLayoutContext = createContext<ViewerLayoutContextValue>(defaultValue);

function ViewerLayoutProvider({
  children,
  layoutMode = 'default',
}: {
  children: ReactNode;
  layoutMode?: ViewerLayoutMode;
}) {
  const value = useMemo(
    () => ({
      layoutMode,
      isPatientMobile: layoutMode === 'patient-mobile',
    }),
    [layoutMode]
  );

  return <ViewerLayoutContext.Provider value={value}>{children}</ViewerLayoutContext.Provider>;
}

const useViewerLayoutContext = () => useContext(ViewerLayoutContext);

export { ViewerLayoutContext, ViewerLayoutProvider, useViewerLayoutContext };
